/**
 * Dots pour horizontal overflow scroll tracks — une pastille par « page »,
 * soit ceil(nombre d’éléments / cartes visibles dans la largeur), pas un point par carte.
 *
 * Scroll : [data-massin-scroll-track]
 * Root : [data-massin-scroll-dots-root]
 * Mount : [data-massin-scroll-dots-mount]
 *
 * data-massin-dots-max : plafonne le nombre de pastilles (après calcul des pages réelles).
 * data-massin-dots-enabled="false" : désactive les pastilles (mais pas le défilement auto si activé séparément)
 * data-massin-dots-mobile-only="true" : dots + autoplay mobiles (≤749px), comme ftabs / cartes collections
 * data-massin-dots-when-single-page="true" : affiche au moins une pastille même sans scroll (ex. 5 cartes × 20 % desktop)
 *
 * Défilement auto (comme marques logos) :
 * data-massin-carousel-autoplay="true"
 * OU data-massin-collection-autoplay="true" (rétrocompat cartes collections)
 * data-massin-carousel-autoplay-ms ou data-massin-collection-autoplay-ms (défaut 3500, min 1000)
 */
(function () {
  function parseMax(root, def) {
    var v = parseInt(root.getAttribute('data-massin-dots-max'), 10);
    return isNaN(v) || v < 1 ? def : v;
  }

  function clamp(n, a, b) {
    return Math.min(b, Math.max(a, n));
  }

  /**
   * Stops pour chaque groupe d’éléments visibles (~une « page » de scroll).
   * Retourne { stops: number[], logicalPages: number }
   * logicalPages = ceil(nb cartes / par écran), même si scrollWidth était mal mesuré.
   */
  function collectPageScrollStops(track) {
    var kids = Array.prototype.slice.call(track.children);

    if (kids.length <= 1) {
      return { stops: [0], logicalPages: 1 };
    }

    var n = kids.length;
    /** Largeur visible utile : si flex gonfle la <ul>, clientWidth suit le contenu et perView saute à n → faux 1 page. */
    var cwTrack = track.clientWidth || 1;
    var vw = cwTrack;
    try {
      if (typeof track.closest === 'function') {
        var cage = track.closest('.page-width,[data-massin-scroll-dots-root]');
        if (cage && cage.clientWidth) {
          vw = Math.min(vw, cage.clientWidth);
        }
      }
    } catch (eCage) {}
    var vwDoc = typeof document.documentElement.clientWidth === 'number' ? document.documentElement.clientWidth : vw;
    if (vwDoc > 0 && vwDoc < vw - 40) vw = vwDoc;

    var el0 = kids[0];

    var step = n > 1 ? kids[1].offsetLeft - kids[0].offsetLeft : el0.offsetWidth;
    if (step < 4) step = Math.max(el0.offsetWidth || 100, 8);
    if (step < 10 && n > 2) {
      var avgStep = (kids[n - 1].offsetLeft - kids[0].offsetLeft) / Math.max(1, n - 1);
      if (avgStep >= 8) step = avgStep;
    }

    step = Math.max(step, 1);
    var perView = Math.max(1, Math.floor(vw / step));
    perView = Math.min(perView, n);

    var numPages = Math.max(1, Math.ceil(n / perView));

    var maxLeftNative = Math.max(0, track.scrollWidth - track.clientWidth);
    var firstLeft = kids[0].offsetLeft;
    var lastKid = kids[n - 1];
    /** Si scrollWidth est sous-estimée, borne max à partir du dernier carte (voir cat. carrousel). */
    var portW = Math.min(cwTrack, vw);
    var contentSpan = lastKid.offsetLeft + lastKid.offsetWidth - firstLeft;
    var extentMax = Math.max(0, Math.round(contentSpan - portW));
    var maxLeft = Math.max(maxLeftNative, extentMax);

    /**
     * Pas de défilement horizontal réel (fractions de px, gap, etc.) → une seule « page » pour les pastilles.
     * Sinon on affiche souvent 2 dots alors que toutes les cartes tiennent (ex. Related products, 4 cols).
     */
    if (maxLeftNative <= 12) {
      return { stops: [0], logicalPages: 1 };
    }

    if (numPages <= 1 && maxLeft < 1) {
      return { stops: [0], logicalPages: 1 };
    }

    var stops = [];
    var p;
    var idx;
    var leftPos;
    for (p = 0; p < numPages; p += 1) {
      idx = Math.min(p * perView, n - 1);
      leftPos = Math.min(kids[idx].offsetLeft, maxLeft);
      if (stops.length === 0 || Math.abs(leftPos - stops[stops.length - 1]) > 6) {
        stops.push(leftPos);
      }
    }

    if (numPages >= 2) {
      var lastIx = stops.length - 1;
      if (lastIx >= 0 && stops[lastIx] < maxLeft - 4) {
        stops[lastIx] = maxLeft;
      }
    }

    stops = stops.filter(function (v, i, arr) {
      return i === 0 || Math.abs(v - arr[i - 1]) > 4;
    });

    /** Encore un seul stop malgré ≥2 pages : positions brutes (évite min(..., 0)). */
    if (stops.length < 2 && numPages >= 2) {
      stops = [];
      for (p = 0; p < numPages; p += 1) {
        idx = Math.min(p * perView, n - 1);
        leftPos = kids[idx].offsetLeft;
        if (stops.length === 0 || Math.abs(leftPos - stops[stops.length - 1]) > 6) {
          stops.push(leftPos);
        }
      }
      if (stops.length >= 2) {
        var li = stops.length - 1;
        var tail = Math.max(maxLeftNative, extentMax, lastKid.offsetLeft);
        if (stops[li] < tail - 4) {
          stops[li] = tail;
        }
      }
    }

    if (numPages >= 2 && stops.length < 2) {
      stops = [kids[0].offsetLeft, kids[Math.min(perView, n - 1)].offsetLeft];
    }

    return { stops: stops, logicalPages: numPages };
  }

  function subsampleStops(raw, maxDots) {
    if (raw.length <= maxDots) return raw.slice();
    var n = raw.length;
    var m = clamp(maxDots, 2, 48);
    var out = [];
    var i;
    for (i = 0; i < m; i += 1) {
      out.push(raw[Math.round((i * (n - 1)) / Math.max(1, m - 1))]);
    }
    var dedup = [];
    out.forEach(function (x) {
      if (!dedup.length || Math.abs(x - dedup[dedup.length - 1]) > 8) dedup.push(x);
    });
    return dedup;
  }

  function nearestIndex(scrollLeft, stops) {
    var best = 0;
    var bestD = Infinity;
    stops.forEach(function (s, i) {
      var d = Math.abs(scrollLeft - s);
      if (d < bestD) {
        bestD = d;
        best = i;
      }
    });
    return best;
  }

  /**
   * Positions pour l’état actif / autoplay : si stops (offsetLeft / extentMax) dépassent le vrai
   * maxScroll, nearestIndex colle toujours au 1er stop (comme Laptops avant correctif pages).
   */
  function syncStopsForActiveDot(track, stops) {
    var len = stops.length;
    var m = Math.max(0, track.scrollWidth - track.clientWidth);
    if (len < 2 || m < 4) {
      return stops;
    }
    var lastRaw = stops[len - 1];
    if (lastRaw <= m + 12) {
      var clamped = stops.map(function (s) {
        return Math.min(m, Math.max(0, s));
      });
      clamped[len - 1] = m;
      return clamped;
    }
    var spaced = [];
    var i;
    for (i = 0; i < len; i += 1) {
      spaced.push(len === 1 ? 0 : (i / (len - 1)) * m);
    }
    return spaced;
  }

  function autoplayReadsTrue(root, key) {
    var v = root.getAttribute(key);
    return v === 'true' || v === '';
  }

  function bind(root) {
    if (root.dataset && root.dataset.massinDotsBound === 'true') return;

    var dotsFeature = root.getAttribute('data-massin-dots-enabled') !== 'false';
    var autoplayOn =
      autoplayReadsTrue(root, 'data-massin-carousel-autoplay') ||
      autoplayReadsTrue(root, 'data-massin-collection-autoplay');

    if (!dotsFeature && !autoplayOn) return;

    var track = root.querySelector('[data-massin-scroll-track]');
    var mount = root.querySelector('[data-massin-scroll-dots-mount]');

    if (!track) return;
    if (!autoplayOn && dotsFeature && !mount) return;

    var showDots = dotsFeature && !!mount;

    root.dataset.massinDotsBound = 'true';

    var maxDots = parseMax(root, 12);
    var dotsWhenSinglePage =
      root.getAttribute('data-massin-dots-when-single-page') === 'true';
    var mobileOnly =
      root.getAttribute('data-massin-dots-mobile-only') === 'true' ||
      root.getAttribute('data-massin-autoplay-mobile-only') === 'true';

    var mqMobile = null;
    try {
      mqMobile = window.matchMedia('(max-width: 749px)');
    } catch (eMedia) {}

    function isMobileCarouselContext() {
      if (!mobileOnly) return true;
      if (mqMobile && mqMobile.matches) return true;
      return window.innerWidth <= 749;
    }

    var reducedMotion = false;
    try {
      reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (eRm) {}

    var stops = [];
    /** Pages logiques ceil(n/perView), pour ne pas traiter comme « une page » si ≥2 dots attendus. */
    var logicalPages = 1;
    var ticking = false;
    var userPaused = false;

    function parseAutoplayMs() {
      var raw =
        root.getAttribute('data-massin-carousel-autoplay-ms') ||
        root.getAttribute('data-massin-collection-autoplay-ms') ||
        '3500';
      var ms = parseInt(raw, 10);
      return isNaN(ms) ? 3500 : Math.max(1000, ms);
    }

    var autoplayMs = parseAutoplayMs();
    var autoplayTimer = null;

    function rebuildStopsOnly() {
      var pageData = collectPageScrollStops(track);
      logicalPages =
        typeof pageData.logicalPages === 'number' ? pageData.logicalPages : 1;
      stops = subsampleStops(pageData.stops, clamp(maxDots, 2, 48));
    }

    function updateMountVisibility() {
      if (!mount) return;
      if (!mobileOnly) {
        mount.classList.remove('massin-carousel-dots--hide-on-desktop');
        return;
      }
      mount.classList.add('massin-carousel-dots--hide-on-desktop');
    }

    function syncActive() {
      if (!showDots) return;
      var dots = mount.querySelectorAll('.massin-carousel-dot');
      if (!dots.length) return;
      var aligned = syncStopsForActiveDot(track, stops);
      var ix = nearestIndex(track.scrollLeft, aligned);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === ix);
      });
    }

    function scheduleSync() {
      if (!showDots) return;
      if (ticking) return;
      window.requestAnimationFrame(function () {
        syncActive();
        ticking = false;
      });
      ticking = true;
    }

    function renderDotsUi() {
      rebuildStopsOnly();
      if (mount && !dotsFeature) {
        mount.innerHTML = '';
        mount.setAttribute('hidden', '');
        return;
      }
      if (!showDots) return;
      updateMountVisibility();

      mount.innerHTML = '';
      mount.setAttribute('aria-label', 'Indicateurs du carrousel');

      var kidsCount = track.children.length;

      if (stops.length <= 1) {
        if (dotsWhenSinglePage && kidsCount >= 1 && logicalPages <= 1) {
          mount.removeAttribute('hidden');
          var one = document.createElement('button');
          one.type = 'button';
          one.className = 'massin-carousel-dot is-active';
          one.setAttribute('aria-label', 'Page unique');
          one.setAttribute('aria-current', 'true');
          one.addEventListener('click', function () {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          });
          mount.appendChild(one);
        } else {
          mount.setAttribute('hidden', '');
        }
      } else {
        mount.removeAttribute('hidden');
        stops.forEach(function (stopLeft, dotIndex) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'massin-carousel-dot';
          btn.setAttribute('aria-label', 'Page ' + (dotIndex + 1));
          btn.addEventListener('click', function () {
            var mx = Math.max(0, track.scrollWidth - track.clientWidth);
            track.scrollTo({ left: Math.min(stopLeft, mx), behavior: 'smooth' });
          });
          mount.appendChild(btn);
        });
      }
      syncActive();
    }

    function maybeRestartAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
      if (!autoplayOn || reducedMotion || userPaused) return;
      rebuildStopsOnly();
      if (stops.length < 2) return;
      if (track.scrollWidth <= track.clientWidth + 2) return;
      if (mobileOnly && !isMobileCarouselContext()) return;

      autoplayMs = parseAutoplayMs();

      autoplayTimer = window.setInterval(function autoplayTick() {
        if (userPaused || reducedMotion) return;
        if (mobileOnly && !isMobileCarouselContext()) return;
        rebuildStopsOnly();
        if (stops.length < 2) return;
        if (track.scrollWidth <= track.clientWidth + 2) return;
        var aligned = syncStopsForActiveDot(track, stops);
        var ix = nearestIndex(track.scrollLeft, aligned);
        var nextIx = (ix + 1) % stops.length;
        track.scrollTo({ left: aligned[nextIx], behavior: 'smooth' });
      }, autoplayMs);
    }

    function fullRebuild() {
      renderDotsUi();
      maybeRestartAutoplay();
    }

    root._massinScrollDotsRebuild = fullRebuild;

    track.addEventListener(
      'scroll',
      scheduleSync,
      { passive: true }
    );

    window.addEventListener('resize', function () {
      fullRebuild();
    });

    function tryRenderSoon() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(fullRebuild);
      });
    }

    tryRenderSoon();

    if (typeof window.ResizeObserver !== 'undefined') {
      try {
        var ro = new window.ResizeObserver(function () {
          fullRebuild();
        });
        ro.observe(track);
      } catch (eObserve) {}
    }

    if (autoplayOn) {
      track.addEventListener(
        'mouseenter',
        function () {
          userPaused = true;
          if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        },
        { passive: true }
      );
      track.addEventListener(
        'mouseleave',
        function () {
          userPaused = false;
          maybeRestartAutoplay();
        },
        { passive: true }
      );
      track.addEventListener(
        'touchstart',
        function () {
          userPaused = true;
          if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        },
        { passive: true }
      );
      track.addEventListener(
        'touchend',
        function () {
          userPaused = false;
          maybeRestartAutoplay();
        },
        { passive: true }
      );
    }

    if (mqMobile && mobileOnly && autoplayOn) {
      var mqHandler = function () {
        fullRebuild();
      };
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', mqHandler);
      else if (mqMobile.addListener) mqMobile.addListener(mqHandler);
    }
  }

  function scan(scope) {
    var rootScope = scope || document;
    rootScope.querySelectorAll('[data-massin-scroll-dots-root]').forEach(bind);
  }

  function refresh() {
    document.querySelectorAll('[data-massin-scroll-dots-root]').forEach(function (root) {
      var fn = root._massinScrollDotsRebuild;
      if (typeof fn === 'function') fn();
    });
  }

  /** Scroll horizontal (liste de blocs enfants directs) — partagé avec logos marques */
  function getPageScrollStops(scroller) {
    return collectPageScrollStops(scroller);
  }

  window.MassinCarouselDots = {
    bind: bind,
    scan: scan,
    refresh: refresh,
    getPageScrollStops: getPageScrollStops
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }
  document.addEventListener(
    'shopify:section:load',
    function (e) {
      scan(e.target || document);
    }
  );
})();
